import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { fetchReports } from 'src/Services/MentorServices/ProjectsService'
import 'src/Pages/LibraryPages/librarypages.scss'

const ACCENTS = ['a-blue', 'a-cyan', 'a-teal', 'a-amber', 'a-emerald', 'a-sky', 'a-navy']

const ReportIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <path d="M14 3v6h6M9 13h6M9 17h4" />
  </svg>
)

const CalendarIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
)

const BackIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M19 12H5M11 18l-6-6 6-6" />
  </svg>
)

const StatusReport = () => {
  const { memberId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)
  const token = localStorage.getItem('token')

  // Get studentName from location state
  const { studentName } = location.state || { studentName: '' }

  const fetchStatusReport = async (memberId) => {
    try {
      const data = await fetchReports(memberId, token)
      setReports(data)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (memberId) {
      fetchStatusReport(memberId)
    }
  }, [memberId])

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <ReportIcon />
          </span>
          <div>
            <h1 className="lpg__title">Status Report</h1>
            <p className="lpg__sub">
              {studentName ? `Progress report for ${studentName}` : 'Member status report.'}
            </p>
          </div>
        </div>
        <button type="button" className="lpg__back" onClick={() => navigate(-1)}>
          <BackIcon /> Back
        </button>
      </div>

      {loading ? (
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      ) : reports.length === 0 ? (
        <div className="lpg__state">No status reports have been submitted yet.</div>
      ) : (
        <div className="lpg__panel-box">
          <div className="lpg__acc" style={{ maxHeight: 520, overflowY: 'auto' }}>
            {reports.map((report, i) => (
              <div
                key={report.reportId}
                className={`lpg__panel is-open ${ACCENTS[i % ACCENTS.length]}`}
              >
                <div className="lpg__panel-head" style={{ cursor: 'default' }}>
                  <span className="lpg__panel-ic">
                    <CalendarIcon />
                  </span>
                  <span className="lpg__panel-name">Week {report.weekNumber}</span>
                  <span className="lpg__count">
                    {new Date(report.submissionDate).toLocaleDateString()}
                  </span>
                </div>
                <div className="lpg__panel-body">
                  <p style={{ margin: 0, lineHeight: 1.5 }}>{report.reportText}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default StatusReport
